/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

import { PaymentMethod, RequestPath, RequestSource } from '../util/constants'
import axios from 'axios'
import { getSessionAuthState } from '../util/util'

const instance = axios.create(
  {
    baseURL: process.env.REACT_APP_CLIENT_PROXY_URL
  }
)

const apiOnGoingLotteries = async () => {
  return await instance.get(RequestPath.LOTTERY_ONGOING)
}

const apiPackages = async () => {
  return await instance.get(RequestPath.LOTTERY_PACKAGE)
}

const apiUserLogin = async ({ mobile }) => {
  return await instance.post(RequestPath.USER_LOGIN, { mobile: mobile })
}

const apiUserLoginVerify = async ({ mobile, otp }) => {
  return await instance.post(RequestPath.VERIFY_OTP, { mobile: mobile, otp: otp })
}

const apiLotteryAllocate = async ({ drawId, packageId, salesType, ticketsId, count }) => {
  const authState = getSessionAuthState()
  return await instance.post(RequestPath.TICKET_ALLOCATE,
    {
      count: count,
      drawId: drawId,
      packageId: packageId,
      paymentMethod: PaymentMethod.MOBILE,
      salesType: salesType,
      source: RequestSource.WEB_WIDGET,
      ticketIds: ticketsId
    }, { headers: { Authorization: authState ? authState.token : null } }
  )
}

const apiSearchLotteryTickets = async ({ drawId, fields }) => {
  return await instance.post(RequestPath.SEARCH_TICKETS, {
    drawId: drawId,
    fields: fields
  })
}

const apiAddMissingNIC = async ({ nic }) => {
  const authState = getSessionAuthState()
  return await instance.patch(RequestPath.ADD_MISSING_NIC, {
    nic: nic
  }, { headers: { Authorization: authState ? authState.token : null } })
}

const tracking = () => {
  axios.get('https://endpoint1.adstudio.cloud/?t=conversion&conv=32')
}

export {
  apiOnGoingLotteries,
  apiPackages,
  apiUserLogin,
  apiUserLoginVerify,
  apiLotteryAllocate,
  apiSearchLotteryTickets,
  apiAddMissingNIC,
  tracking
}
